__webpack_require__.p = "/removing-legacy-ratings/onboarding/";